import React, { useState } from "react";

const GdprInfo = () => {
  const [hidden, setHidden] = useState(true);
  const text =
    "Výše uvedené osobní údaje budou zpracovávány na základě čl. 6, odst. 1 písm. e) Obecného nařízení o ochraně osobních údajů (GDPR) pro splnění úkolu prováděného ve veřejném zájmu nebo při výkonu veřejné moci. Vytvořením rezervace udělujete souhlas pro jejich zpracování v nezbytném rozsahu. Existence záznamu v rezervačním systému je považována za doložení souhlasu se zpracováním osobních údajů podle čl. 7 GDPR a to za účelem obsloužení ve vyvolávacím systému.";

  return (
    <>
      <p className="mx-6 text-sm text-secondary font-light">
        <span className="font-bold">Zpracování osobních údajů</span>
      </p>
      <p className="mx-6 mt-0 text-sm text-secondary font-light">
        {hidden && <span className="line-clamp-1">{text}</span>}
        {!hidden && text}
      </p>
      <button className="text-bold uppercase text-sm mx-6 mt-1 text-accent-dark" onClick={() => setHidden(!hidden)}>
        {hidden ? "Více informací" : "Méně informací"}
      </button>
    </>
  );
};

export default GdprInfo;
